export const FIELD_TYPES = {
  ADDRESS_FIELDS: 'address-fields',
  PHONE_FIELD: 'phone-field',
  ADDRESS_FIELD: 'address-field',
  CHECKBOX_GROUP_FIELD: 'checkbox-group-field',
  CHECKBOX_FIELD: 'checkbox-field',
  TEXT_FIELD: 'text-field',
  FILE_FIELD: 'file-field',
  DATE_FIELD: 'date-field',
  RADIO_GROUP_FIELD: 'radio-group-field',
  SELECT_FIELD: 'select-field',
  TEXTAREA_FIELD: 'textarea-field',
  ID_FIELDS: 'id-fields',
  COUNTRIES_SELECT_FIELD: 'countries-select-field',
  EXPIRING_ID_FIELDS: 'expiring-id-fields',
  EXPIRING_FILE_FIELD: 'expiring-file-field',
  SWITCH_FIELD: 'switch-field'
}
export const IDENTITY_DOCUMENT_TYPE_OPTIONS = [
  {value: 'identity', label: 'Identity card'},
  {value: 'passport', label: 'Passport'},
  {value: 'license', label: 'Driver license'},
  {value: 'cancheck', label: 'CanChek ID verification'}
]
